import { useCallback, useMemo, useRef, useState } from "react";
import Input from "../Inputs/InputRef";
import * as Yup from "yup";
import { Form } from "@unform/web";
import { FormHandles } from "@unform/core";

import {
  DivBoxInput,
  DivContainer,
  DivForm,
  DivSelect,
  Title1,
  Title2,
  ErrorText,
  ButtonSend,
  DivButtonContainer,
} from "./styles";
import { Autocomplete } from "@mui/material";
import { TextField } from "unform-material-ui";
import api from "../../services/api/index";
import { useProgress } from "../../hooks/progress";
import Estados from "../../utils/Estados/Estados.json";
import Cidades from "../../utils/Cidades/Cidades.json";
import ModalCEP from "../Modais/ModalCEP";
import ModalCalculadora from "../Modais/ModalCalculadora";
import ModalConsumoMinimo from "../Modais/ModalConsumoMinimo";
import getValidationErrors from "../../utils/getValidationErrors";
import { IDataCalculadoraEndereco, IDataCalculator } from "../../@Types";
import Toast from "../Toast/Toast";
import checkIcon from "../Toast/Image/check.svg";
import errorIcon from "../Toast/Image/error.svg";
import { readDataStorage } from "../../utils/storage/storage";

export const Calculadora = () => {
  const { setLoad } = useProgress();
  const [media, setMedia] = useState<number>(0);
  const [checkMedia, setCheckMedia] = useState<boolean>(false);

  const [modalIsOpenCEP, setIsOpenCEP] = useState(false);
  const [modalIsOpenLink, setIsOpenLink] = useState(false);
  const [modalIsOpenConsumoMinimo, setIsOpenConsumoMinimo] = useState(false);
  const [calculo, setCalculo] = useState("");
  const [mensalidade, setMensalidade] = useState("");
  const [consumoMinimo, setConsumoMinimo] = useState("");
  const [mediaFinal, setMediaFinal] = useState("");

  const [, /*CEPvalido*/ setCEPvalido] = useState();
  const [defaultEstado, setDefaultEstado] = useState<number>(0);
  const [defaultCity, setDefaultCity] = useState<number>(0);
  const [cidades /*setCidades*/] = useState<any>(Cidades);
  const Ref = useRef<FormHandles>(null);
  const [concessionaria, setConcessionaria] = useState<any>([]);
  const [concessionariaFim, setConcessionariaFim] = useState<any>("");

  const [list, setList] = useState<any>([]);

  const {
    Grupo,
  } = readDataStorage("login");

  const showToast = useCallback(
    (type: any) => {
      let toastProperties: {
        id: number;
        title: string;
        description: string;
        backgroundColor: string;
        icon: any;
      } | null = null;

      const id = Math.floor(Math.random() * 101 + 1);
      switch (type) {
        case "success":
          toastProperties = {
            id,
            title: "",
            description: "Cadastro salvo com sucesso",
            backgroundColor: "#5cb85c",
            icon: checkIcon,
          };
          break;
        case "catchListBanks":
          toastProperties = {
            id,
            title: "",
            description: "Falha ao listar bancos",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "catchBuscarCep":
          toastProperties = {
            id,
            title: "",
            description: "Não encontramos o CEP informado",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "catchSalvarRegistro":
          toastProperties = {
            id,
            title: "",
            description: "Falha ao Salvar Registro",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "CEP":
          // eslint-disable-next-line
          toastProperties = {
            id,
            title: "",
            description: "Cidade e Estado são alterados somente através do CEP",
            backgroundColor: "#f0ad4e",
            icon: errorIcon,
          };
          break;
        default:
          setList([]);
      }

      setList([...list, toastProperties]);
    },
    [list]
  );

  function disableInputCep() {
    showToast("CEP");
  }

  const classes = useMemo(
    () => [
      { value: "Monofásico", label: "Monofásico" },
      { value: "Bifásico", label: "Bifásico" },
      { value: "Trifásico", label: "Trifásico" },
    ],
    []
  );

  const subClasse = useMemo(
    () => [
      { value: "Residencial", label: "Residencial" },
      { value: "Comercial", label: "Comercial" },
      { value: "Rural", label: "Rural" },
      { value: "Industrial", label: "Industrial" },
      { value: "Outros", label: "Outros" },
    ],
    []
  );

  const meses = useMemo(
    () => [
      { id: "inputMes1", label: "Jan", value: 0 },
      { id: "inputMes2", label: "Fev", value: 0 },
      { id: "inputMes3", label: "Mar", value: 0 },
      { id: "inputMes4", label: "Abr", value: 0 },
      { id: "inputMes5", label: "Mai", value: 0 },
      { id: "inputMes6", label: "Jun", value: 0 },
      { id: "inputMes7", label: "Jul", value: 0 },
      { id: "inputMes8", label: "Ago", value: 0 },
      { id: "inputMes9", label: "Set", value: 0 },
      { id: "inputMes10", label: "Out", value: 0 },
      { id: "inputMes11", label: "Nov", value: 0 },
      { id: "inputMes12", label: "Dez", value: 0 },
    ],
    []
  );

  const listaConcessionaria = useCallback(
    async (value) => {
      setLoad(true);
      setConcessionariaFim("");
      await api
        .get("/csp/estadoconce/consultar/" + value)
        .then((res) => {
          let arrayConcessionarias = [];
          const {
            data: { concessionarias },
          } = res;
          for (const k in concessionarias) {
            const { nome, id } = concessionarias[k];
            arrayConcessionarias.push({ value: id, label: nome });
          }
          setConcessionaria(arrayConcessionarias);
        })
        .catch((err) => {
          setLoad(false);
          console.error(err);
        });
      setLoad(false);
    },
    [setLoad]
  );

  const handleBlurCEP = useCallback(
    (e: any) => {
      const { value } = e.target;
      let cep = value.replace(/\D/g, "");
      if (cep.length === 8) {
        api
          .get(`/csp/consultacep/cep/${cep}`)
          .then((response) => {
            if (response.status === 200) {
              setCEPvalido(response.data.message.valido);
              if (response.data.message.valido === 1) {
                const { message } = response.data;
                listaConcessionaria(message.siglauf);
                if (message) {
                  // eslint-disable-next-line
                  Ref.current?.setFieldValue("enderecoBairro", message.bairro);
                  // eslint-disable-next-line
                  Ref.current?.setFieldValue(
                    "enderecoLogradouro",
                    message.logradouro
                  );
                  // eslint-disable-next-line
                  Ref.current?.setFieldValue(
                    "enderecoComplemento",
                    message.complemento
                  );
                  // eslint-disable-next-line
                  Ref.current?.setFieldValue(
                    "enderecoCidade",
                    message.localidade
                  );
                  // eslint-disable-next-line
                  Ref.current?.setFieldValue("enderecoEstado", message.uf);

                  const indexUf = Estados.map((el: any) => el.id).indexOf(
                    message.uf
                  );
                  if (indexUf !== -1) {
                    setDefaultEstado(indexUf);
                  }
                  const indexCity = cidades
                    .map((el: { label: any }) => el.label)
                    .indexOf(message.localidade);
                  if (indexCity !== -1) {
                    setDefaultCity(indexCity);
                  }
                } else {
                  setDefaultEstado(defaultEstado);
                  setDefaultCity(defaultCity);
                }
              } else {
                setIsOpenCEP(true);
              }
            }
          })
          .catch((err) => {
            showToast("catchBuscarCep");
          });
      }
    },
    [cidades, defaultEstado, defaultCity, listaConcessionaria, showToast]
  );

  const closeModal = () => {
    setIsOpenCEP(false);
    setIsOpenLink(false);
    setIsOpenConsumoMinimo(false);
  };

  const handleChangeValue = (e: any) => {
    let index = 0;
    let soma = 0;
    const { value } = e.target;
    e.target.value = value.replace(/\D/g, "");

    const findIndex = meses.find(({ id }) => id === e.target.id);

    meses.forEach((elem) => {
      if (elem.id === findIndex?.id) {
        elem.value = value;
      }
      if (elem.value > 0) {
        soma += Math.trunc(elem.value);
        index++;
      }
      setMedia(Math.trunc(soma / index));

      if (soma > 0) {
        setCheckMedia(false);
      }
      return true;
    });
  };

  const handleChangeCEP = useCallback((e: any) => {
    const { value } = e.target;
    e.target.value = value
      .replace(/\D/g, "")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{3})(\d+?)$/, "$1");
  }, []);

  const dataSend = useCallback(
    (data) => {
      const dataEndereco: IDataCalculadoraEndereco = {
        CEP: data.enderecoCEP,
        estado: data.enderecoEstado,
        concessionaria: data.concessionaria,
        classe: data.classe,
        subClasse: data.subClasse,
        consumoJan: meses[0].value,
        consumoFev: meses[1].value,
        consumoMar: meses[2].value,
        consumoAbr: meses[3].value,
        consumoMai: meses[4].value,
        consumoJun: meses[5].value,
        consumoJul: meses[6].value,
        consumoAgo: meses[7].value,
        consumoSet: meses[8].value,
        consumoOut: meses[9].value,
        consumoNov: meses[10].value,
        consumoDez: meses[11].value,
      };

      const dataForm: IDataCalculator = {
        endereco: dataEndereco,
      };

      return dataForm;
    },
    [meses]
  );

  const handleSubmit = useCallback(
    async (data) => {
      try {
        // eslint-disable-next-line
        Ref.current?.setErrors({});
        data["average"] = media;
        let schema = Yup.object();

        schema = schema.shape({
          // dados informe consumo
          classe: Yup.string().required("Informe a Classe"),
          subClasse: Yup.string().required("Informe o Grupo Tarifário"),
          average: Yup.number().positive(
            "Deve ser informado pelo menos um mês de consumo"
          ),
          concessionaria: Yup.string().required("Informe a concessionária"),
          // dados endereco
          enderecoCEP: Yup.string().required("Informe o CEP"),
          enderecoEstado: Yup.string().required(
            "Informe a unidade da federação"
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const sendData = dataSend(data);
        setLoad(true);

        await api
          .post("/csp/proposta/gerar/", {
            concessionaria: sendData.endereco.concessionaria,
            subClasse: sendData.endereco.subClasse,
            estado: sendData.endereco.estado,
            classe: sendData.endereco.classe,
            grupo:Grupo,
            consumo: {
              jan: sendData.endereco.consumoJan,
              fev: sendData.endereco.consumoFev,
              mar: sendData.endereco.consumoMar,
              abr: sendData.endereco.consumoAbr,
              mai: sendData.endereco.consumoMai,
              jun: sendData.endereco.consumoJun,
              jul: sendData.endereco.consumoJul,
              ago: sendData.endereco.consumoAgo,
              set: sendData.endereco.consumoSet,
              out: sendData.endereco.consumoOut,
              nov: sendData.endereco.consumoNov,
              dez: sendData.endereco.consumoDez,
            },
          })
          .then((res) => {
            setLoad(true);
            if (res.status === 200) {
              setLoad(false);
              setCalculo(res.data.mensagem["economiaAnual"]);
              setMensalidade(res.data.mensagem["mensalidade"]);
              setConsumoMinimo(res.data.mensagem["consumoMinimo"]);
              setMediaFinal(res.data.mensagem["mediaFinal"]);
              if (res.data.mensagem["proposta"] === 1) {
                setIsOpenLink(true);
              }
              if (res.data.mensagem["proposta"] === 0) {
                setIsOpenConsumoMinimo(true);
              }
            }
          })
          .catch((error) => {
            setLoad(false);
            showToast("catchSalvarRegistro");
          });
        setLoad(false);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          // eslint-disable-next-line
          Ref.current?.setErrors(errors);
          if (errors["average"]) {
            setCheckMedia(true);
          }
        } else {
          showToast("catchSalvarRegistro");
        }
      }
      setLoad(false);
    },
    [setLoad, media, dataSend, showToast]
  );

  const handleChangeConcessionaria = useCallback((e: any) => {
    setConcessionariaFim(e.label);
  }, []);

  return (
    <>
      <ModalCEP isOpen={modalIsOpenCEP} onRequestClose={closeModal} />
      <ModalCalculadora
        isOpen={modalIsOpenLink}
        onRequestClose={closeModal}
        calculo={calculo}
        mensalidade={mensalidade}
        consumoMinimo={consumoMinimo}
        mediaFinal={mediaFinal}
      />
      <ModalConsumoMinimo
        isOpen={modalIsOpenConsumoMinimo}
        onRequestClose={closeModal}
      />
      <Toast toastList={list} autoDelete={true} />
      <DivForm>
        <Form ref={Ref} onSubmit={handleSubmit}>
          <Title1>Calculadora de proposta</Title1>
          <DivContainer>
            <DivSelect>
              <Autocomplete
                disablePortal
                options={classes}
                id="inputClasseARP"
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Classe"
                    name="classe"
                    variant="outlined"
                  />
                )}
              />
            </DivSelect>
            <DivSelect>
              <Autocomplete
                disablePortal
                options={subClasse}
                id="inputSubClasseARP"
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Grupo Tarifário"
                    name="subClasse"
                    variant="outlined"
                  />
                )}
              />
            </DivSelect>
          </DivContainer>

          <Title2>Preencha o histórico de consumo dos últimos meses*:</Title2>
          <DivBoxInput>
            <Input
              name={meses[0].id}
              label={meses[0].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[1].id}
              label={meses[1].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[2].id}
              label={meses[2].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[3].id}
              label={meses[3].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[4].id}
              label={meses[4].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[5].id}
              label={meses[5].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[6].id}
              label={meses[6].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[7].id}
              label={meses[7].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[8].id}
              label={meses[8].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[9].id}
              label={meses[9].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[10].id}
              label={meses[10].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
            <Input
              name={meses[11].id}
              label={meses[11].label}
              type="text"
              onChange={handleChangeValue}
              maxLength={8}
            />
          </DivBoxInput>
          {checkMedia ? (
            <ErrorText>
              Deve ser informado pelo menos um mês de consumo
            </ErrorText>
          ) : (
            <></>
          )}

          <Title2>Dados de endereço:</Title2>
          <DivContainer>
            <Input
              type="text"
              id="inputEnderecoCEP"
              name="enderecoCEP"
              placeholder="CEP"
              label="CEP"
              onChange={handleChangeCEP}
              onBlur={handleBlurCEP}
            ></Input>
            <span onClick={() => disableInputCep()}>
              <Input
                type="text"
                name="enderecoEstado"
                id="inputEnderecoEstado"
                placeholder="Estado"
                label="Estado"
                disabled
              ></Input>
            </span>
            <span onClick={() => disableInputCep()}>
              <Input
                type="text"
                id="inputEnderecoCidade"
                name="enderecoCidade"
                placeholder="Cidade"
                label="Cidade"
                disabled
              ></Input>
            </span>
          </DivContainer>

          <Title2>Selecione a concessionária:</Title2>
          <DivContainer>
            <DivSelect>
              <Autocomplete
                disablePortal
                options={concessionaria}
                id="concessionaria"
                size="small"
                noOptionsText={"Selecione o estado"}
                //getOptionLabel={(option: any) => option.label}
                onChange={(event, label) => handleChangeConcessionaria(label)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={concessionariaFim}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecione a concessionária"
                    name="concessionaria"
                    inputRef={Ref}
                    value={concessionariaFim}
                    variant="outlined"
                  />
                )}
              />
            </DivSelect>
          </DivContainer>

          <DivButtonContainer>
            <ButtonSend type="submit" id="btnGerarARP">
              Calcular proposta
            </ButtonSend>
          </DivButtonContainer>
        </Form>
      </DivForm>
    </>
  );
};
export default Calculadora;
